import { useLanguage } from '../i18n/LanguageContext';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

export const LanguageSwitcher = ({ variant = "default" }) => {
  const { language, toggleLanguage } = useLanguage();

  if (variant === "minimal") {
    return (
      <button
        onClick={toggleLanguage}
        className="flex items-center gap-1 text-sm text-slate-600 hover:text-slate-900 transition-colors"
        data-testid="language-switcher"
      >
        <Globe className="w-4 h-4" />
        <span className="font-medium">{language === 'es' ? 'EN' : 'ES'}</span>
      </button>
    );
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="rounded-full flex items-center gap-2"
      data-testid="language-switcher"
    >
      <Globe className="w-4 h-4" />
      <span>{language === 'es' ? 'English' : 'Español'}</span>
    </Button>
  );
};
